module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAApUlEQVQoU42S4REBMRBG33VAB0qgAypAB3Sgg6MDHVCCEpSgBCqggzNvJjkrc0P2V7LZl/32Sxo+sQfasM/LF7AAbiaaUNABY8CCGOYfwEqoBOI+QwIz4CJUC/TyaoAveREYDegvPegyMAdO6XQLXAfcMtUD9+SCSYeb/AO00i7VgLcuA7D+1eEITIFNKjqnV90VkKY8HVo5As5hqN9vYIGPFuPwBua0JqUgXaL0AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Shape2.png
// module id = HKAP
// module chunks = 2